<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <div class="panel-title">
      <h2>Storico Notifiche</h2>
    </div>

    <section class="notifications-list">
      @if (notifications.length === 0) {
        <div>
          <p>Non ci sono notifiche da mostrare</p>
        </div>
      }
      @for (notification of notifications; track notification) {
        <div class="notification">
          <p class="notification-date">
            {{ formatNotificationDate(notification.created_at) }}
          </p>
          <p class="notification-type">
            {{ getNotificationTypeDescription(notification.type) }}
          </p>
        </div>
      }
    </section>

    <div class="panel-buttons">
      <button class="button" (click)="onClose()">Chiudi</button>
    </div>
  </div>
</div>
